import {EntityService} from '../../../service/EntityService';

export class DeclareRegisterInvoiceService extends EntityService {

  static entity = 'app/declare-register-invoice';

  static downloadXml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/download-xml/${id}`, {responseType: 'blob'}).then(res => res.data);
  }

  static getPdfUrl(id: string): string {
    return `${this.baseURL}/${this.entity}/${id}/downloaf-pdf`;
  }

  static getUploadFileAcceptance(id: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/${id}/upload-file-acceptance`, data).then(res => res.data);
  }

  static extentsDeclaration(): Promise<any> {
    return this.axios.get(`${this.entity}/last-declaration`).then(res => res.data);
  }

}
